interface IOfferPayload {
    catalogOfferCode: string;
    catalogTariffPlanCode: string;
    portIn: boolean;
}

export const getStateToPayload = (catalogOfferCode: string, catalogTariffPlanCode: string, portIn: boolean): IOfferPayload => ({ catalogOfferCode,catalogTariffPlanCode,portIn });
